import { useEffect, useState, useCallback, createContext, useContext } from "react";
import { http, ADMIN_TOKEN_KEY } from "../lib/api";

const NotifContext = createContext({
  counts: { mensajes_nuevos: 0, formularios_nuevos: 0, total_pendientes: 0 },
  refresh: () => {},
});

export function NotificationsProvider({ children }) {
  const [counts, setCounts] = useState({
    mensajes_nuevos: 0,
    formularios_nuevos: 0,
    total_pendientes: 0,
  });

  const refresh = useCallback(async () => {
    if (!localStorage.getItem(ADMIN_TOKEN_KEY)) return;
    try {
      const { data } = await http.get("/admin/notifications/counts");
      setCounts(data);
    } catch {
      // silent
    }
  }, []);

  useEffect(() => {
    refresh();
    const i = setInterval(refresh, 30000);
    return () => clearInterval(i);
  }, [refresh]);

  return (
    <NotifContext.Provider value={{ counts, refresh }}>
      {children}
    </NotifContext.Provider>
  );
}

export function useNotifications() {
  return useContext(NotifContext);
}
